<his-plam [label]="setting().label | hisUi"
          [helptext]="setting().helptext | hisUi" [required]="setting().required"
          [title]="title()" renderLabelAsDiv>
    <his-file-upload [configKey]="setting().configKey" #content [(ngModel)]="setting().value" />
</his-plam>
